import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import { usePageParams } from 'src/utils/params'

import routes from 'src/lib/rails-routes/rails-routes'

import CourseSelector from '../CourseSelector/CourseSelector'

import CourseActions from './CourseActions'
import MyCourseHeaderSkeleton from './MyCourseHeaderSkeleton'

const MyCourseHeader = ({
  courseListEmpty,
  cefrLevels,
  selectedCefrLevel,
  currentCefrLevel,
  isEditMode,
  hideActions,
  onToggleEditMode,
}) => {
  const { l2Code } = usePageParams()

  const handleCourseSelection = (cefrLevel) => {
    window.location = routes.advanced_my_course(l2Code, {
      cefr_level: cefrLevel.code,
    })
  }

  return (
    <MyCourseHeaderSkeleton
      nameSection={
        <Box as="h3" variant="text.h3" fontSize={{ _: 'sm', tabletWide: 'lg' }}>
          {t('My Course')}
        </Box>
      }
      cefrLevelSection={
        cefrLevels && (
          <CourseSelector
            currentlySelectedCourse={selectedCefrLevel}
            currentCefrLevel={currentCefrLevel}
            options={cefrLevels}
            onSelectCourse={handleCourseSelection}
          />
        )
      }
      actionsSection={
        !hideActions && (
          <CourseActions
            onToggleEditMode={onToggleEditMode}
            isEditMode={isEditMode}
            courseListEmpty={courseListEmpty}
          />
        )
      }
    />
  )
}

const cefrLevelShape = PropTypes.shape({
  code: PropTypes.string,
  label: PropTypes.string,
})

MyCourseHeader.propTypes = {
  courseListEmpty: PropTypes.bool,
  cefrLevels: PropTypes.arrayOf(cefrLevelShape),
  selectedCefrLevel: cefrLevelShape,
  currentCefrLevel: cefrLevelShape,
  isEditMode: PropTypes.bool.isRequired,
  hideActions: PropTypes.bool,
  onToggleEditMode: PropTypes.func,
}

export default MyCourseHeader
